import React from 'react';
import PolicyLayout from '../components/PolicyLayout';

const PrivacyPolicy: React.FC = () => {
  return (
    <PolicyLayout title="Privacy Policy" image="/images/fhome-ghee-sweets.jpg">
      <p>
        This Privacy Policy describes how FHome collects, uses, stores, and protects personal data
        provided through https://fhome.shop/.
      </p>

      <h3>Information We Collect</h3>
      <ul>
        <li>Account details such as name, email, phone, and address.</li>
        <li>Transaction and order-related information.</li>
        <li>Optional payment-related details processed through secure providers.</li>
      </ul>

      <h3>How We Use Information</h3>
      <ul>
        <li>To process orders and provide customer support.</li>
        <li>To improve platform experience and prevent fraud.</li>
        <li>To send updates, offers, or service communications where permitted.</li>
      </ul>

      <h3>Data Sharing</h3>
      <p>
        Data may be shared with logistics partners, payment providers, and legal authorities where required
        to fulfill services and comply with law.
      </p>

      <h3>Security and Retention</h3>
      <p>
        Reasonable security safeguards are applied to protect personal data. Data is retained only for as long
        as required by business and legal obligations.
      </p>

      <h3>Your Rights</h3>
      <p>
        You may request access, correction, or deletion of your data by contacting support.
      </p>
    </PolicyLayout>
  );
};

export default PrivacyPolicy;
